<template>
    <v-row no-gutters align="center" justify="center" class="fill-height">
        <v-col cols="10" align="center" class="mt-4">
            <v-card :width="width" :height="height">
                <v-card-title class="d-flex align-center justify-center">AI Tester (Beta)
                    <v-spacer></v-spacer>
                    <v-btn color="error" outlined @click="clearChat()">Clear Chat</v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card flat :height="height - 125">
                    <v-card-text>
                        <v-row no-gutters align="end" justify="end">
                            <v-col cols="3">
                                <v-select :items="languages" item-text="name" item-value="code"
                                    v-model="selectedLanguage" outlined dense height="40px" class="mx-3"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text id="msg-container" v-if="aiConversation.length > 0">
                        <v-card id="chatContainer" :height="height - 245" class="overflow-y-auto" flat>
                            <div v-for="(msg, index) in aiConversation" :key="index" class="pa-0 ma-2">
                                <v-container :class="msg.isMe ? 'd-flex justify-end' : 'd-flex justify-start'"
                                    class="pa-0 ma-0">
                                    <v-card class="py-1 px-2 ml-2 white--text text-subtitle-1 text-left" rounded="lg"
                                        :color="msg.isMe ? 'primary' : 'secondary'" max-width="60%" min-width="25%">
                                        <span v-html="msg.message"></span>
                                        <div v-if="!msg.isMe">
                                            <br>
                                            <span>Action: {{ msg.intent }}</span>
                                            <br>
                                            <span v-if="msg.intentname === 'showmap'">Map Name: {{ msg.mapname
                                            }}</span>
                                            <span v-if="msg.intentname === 'searchbylinkid'">Link Id: {{ msg.linkid
                                            }}</span>
                                        </div>
                                    </v-card>
                                </v-container>
                                <span v-if="msg.isMe" class="d-flex justify-end pr-2 ml-10 text-caption">You {{
                                    msg.date
                                    }}</span>
                                <span v-else class="d-flex justify-start pl-2 text-caption">Tracey {{ msg.date
                                    }}</span>
                            </div>
                            <v-container class="d-flex justify-start pa-0 ma-0" v-if="isThinking">
                                <v-card width="150" height="45"
                                    class="d-flex align-center justify-center white--text text-subtitle-1 ml-4"
                                    color="secondary" rounded="lg">
                                    <div id="thinking-text">{{ thinkingText }}</div>
                                </v-card>
                            </v-container>
                        </v-card>
                    </v-card-text>
                    <v-card-text class="d-flex align-center justify-center" v-else>
                        <v-row no-gutters>
                            <!-- <v-col cols="12" class="d-flex align-center justify-center">
                                <v-img src="@/assets/customer-service.png" max-width="150" contain></v-img>
                            </v-col> -->
                            <v-col cols="12" class="d-flex align-center justify-center mt-5">
                                <span class="black--text font-weight-bold justify-center">
                                    Hi, I'm Tracey, <br> I can assist you with court related question
                                </span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-divider></v-divider>
                <v-card-text>
                    <v-text-field v-if="!pastConversation" dense label="Ask court/county related question"
                        v-model="question" append-outer-icon="mdi-send" @click:append-outer="sendMessage"
                        @keyup.enter="sendMessage"></v-text-field>
                    <v-text-field v-else dense label="Click on 'Clear Chat' top right to start a new conversation."
                        v-model="question" append-outer-icon="mdi-send" @click:append-outer="sendMessage" disabled
                        @keyup.enter="sendMessage"></v-text-field>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="2">
            <v-card :height="height + 80" width="100%" class="mx-2">
                <v-card-title>Chat History</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-list>
                        <template v-for="(conversation, index) in getPastConversations">
                            <v-list-item :key="index" @click="loadConversation(conversation)">
                                <v-list-item-content>
                                    <v-list-item-title> {{ conversation.sessionId }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider :key="conversation.sessionId"></v-divider>
                        </template>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
const axios = require('axios');
import moment from 'moment';
import { mapGetters } from 'vuex';
import crypto from "crypto"
export default {
    name: 'aiTester',
    data() {
        return {
            width: window.innerWidth - 1000,
            height: window.innerHeight - 150,
            question: '',
            //conversation: [],
            languages: [
                { name: 'English', code: 'en' },
                { name: 'Español', code: 'es-US' },
            ],
            selectedLanguage: 'en',
            isThinking: false,
            dotCount: 0,
            thinkingText: "Thinking",
            interval: null,
            pastConversation: false,
        }
    },
    watch: {
        aiConversation() {
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        },

    },
    computed: {
        ...mapGetters(['isClientAdmin', 'isSuperAdmin', 'userProfile', 'aiConversation', 'getPastConversations']),
    },
    methods: {
        clearChat() {
            this.$store.commit('clearConversation');
            this.pastConversation = false
        },
        getDate() {
            return moment().format('LTS')
        },
        changeLanguage(code) {
            this.selectedLanguage = code
        },
        sendMessage() {
            if (this.aiConversation.length === 0) {
                this.$store.commit('setConversationSession', crypto.randomBytes(50).toString("hex").slice(0, 15))
            }
            this.$store.commit('setConversation', { isMe: true, message: this.question, date: moment().format('LTS') });
            this.$store.dispatch('saveConversationToStrapi', { isMe: true, message: this.question, date: moment().format('LTS') })
            this.callAI(this.question);
            this.question = '';
        },
        loadConversation(conObj) {
            this.pastConversation = true
            console.log('Past Conversation: ', conObj)
            this.$store.commit('clearConversation');
            conObj.conversation.forEach(conv => {
                this.$store.commit('setConversation', conv);
            })
        },
        callAI(question) {
            this.isThinking = true
            let data;
            if (this.selectedLanguage === 'en') {
                data = JSON.stringify({
                    "question": question,
                    "lang": "english"
                });
            } else {
                data = JSON.stringify({
                    "question": question,
                    "lang": "spanish"
                });
            }

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://ars-williammary-dot-project-bluebox.uc.r.appspot.com/api/query',
                //url: 'http://localhost:3000/api/query',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            axios.request(config)
                .then((response) => {
                    console.log('response from AI: ', response.data.answer);
                    if (response.data.answer.intent === 'showmap') {
                        this.$store.commit('setConversation', { isMe: false, message: response.data.answer.response, intentname: 'showmap', intent: 'Map will be displayed on the kiosk', mapname: response.data.answer.metadata.mappath, date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: response.data.answer.response, intentname: 'showmap', intent: 'Map will be displayed on the kiosk', mapname: response.data.answer.metadata.mappath, date: moment().format('LTS') })
                    } else if (response.data.answer.intent === 'searchbylinkid') {
                        this.$store.commit('setConversation', { isMe: false, message: response.data.answer.response, intentname: 'searchbylinkid', intent: 'Faq associated with linkid will be displayed on the kiosk', linkid: response.data.answer.metadata.linkid, date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: response.data.answer.response, intentname: 'searchbylinkid', intent: 'Faq associated with linkid will be displayed on the kiosk', linkid: response.data.answer.metadata.linkid, date: moment().format('LTS') })
                    } else if (response.data.answer.intent === 'speak') {
                        this.$store.commit('setConversation', { isMe: false, message: response.data.answer.response, intentname: 'speak', intent: 'Response will be displayed on the kiosk', date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: response.data.answer.response, intentname: 'speak', intent: 'Response will be displayed on the kiosk', date: moment().format('LTS') })
                    } else if (response.data.answer.intent === 'greeting' || response.data.answer.intent === 'greet') {
                        this.$store.commit('setConversation', { isMe: false, message: response.data.answer.response, intentname: 'speak', intent: 'Greeting', date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi',)
                    } else if (response.data.answer.intent === 'fallback') {
                        if (response.data.answer.metadata.questiontype === 'general') {
                            this.$store.commit('setConversation', { isMe: false, message: response.data.answer.response, intentname: 'speak', intent: 'Response will be displayed on the kiosk', date: moment().format('LTS') });
                            this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: response.data.answer.response, intentname: 'speak', intent: 'Response will be displayed on the kiosk', date: moment().format('LTS') })
                        } else {
                            this.$store.commit('setConversation', { isMe: false, message: response.data.answer.response, intentname: 'speak', intent: 'User will be directed to default location.', date: moment().format('LTS') });
                            this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: response.data.answer.response, intentname: 'speak', intent: 'User will be directed to default location.', date: moment().format('LTS') })
                        }
                    } else if (response.data.answer.intent === 'followup') {
                        this.$store.commit('setConversation', { isMe: false, message: response.data.answer.response, intentname: 'followup', intent: 'Followup prompt will be displayed on the kiosk.', date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: response.data.answer.response, intentname: 'followup', intent: 'Followup prompt will be displayed on the kiosk.', date: moment().format('LTS') })
                    } else if (response.data.answer.intent === 'navigate') {
                        this.$store.commit('setConversation', { isMe: false, message: response.data.answer.response, intentname: 'navigate', intent: 'The application will be navigated to the respective page.', date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: response.data.answer.response, intentname: 'navigate', intent: 'The application will be navigated to the respective page.', date: moment().format('LTS') })
                    }
                    else {
                        this.$store.commit('setConversation', { isMe: false, message: 'Something went wrong. Please try again with a different question.', intentname: 'speak', intent: 'Error', date: moment().format('LTS') });
                        this.$store.dispatch('saveConversationToStrapi', { isMe: false, message: 'Something went wrong. Please try again with a different question.', intentname: 'speak', intent: 'Error', date: moment().format('LTS') })
                    }
                    this.isThinking = false
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        scrollToBottom() {
            const container = document.getElementById('chatContainer');
            if (container) {
                container.scrollTop = container.scrollHeight;
            }
        }
    },
    filters: {
        formatDate(val) {
            if (!val) { return '-' }
            return moment(val).format('LTS')
        },
    },
    mounted() {
        console.log('User Profile at AI tester: ', this.userProfile.data())
        this.scrollToBottom();
        this.interval = setInterval(() => {
            this.dotCount = (this.dotCount + 1) % 4; // 0 to 3
            this.thinkingText = "Thinking" + ".".repeat(this.dotCount);
        }, 500);
        this.$store.dispatch('pullPastConversations')
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
}
</script>
<style>
.chatCard {
    border-width: 1px;
    border-style: solid;
    border-color: grey !important;
    border-radius: 15px !important;
}

.scrollable-content {
    overflow-y: auto;
    max-height: calc(100%)
}

.thinking-text {
    font-size: 24px;
    font-weight: bold;
    animation: pulse 1s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.6;
    }

    100% {
        opacity: 1;
    }
}
</style>